'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _appMisc = require('../../../app.misc.js');

var _lodash = require('lodash');

var _dialogConfig = require('../../../common/models/dialog/dialogConfig.js');

var _dialogConfig2 = _interopRequireDefault(_dialogConfig);

var _dialogButton = require('../../../common/models/dialog/dialogButton.js');

var _dialogButton2 = _interopRequireDefault(_dialogButton);

var _dialogColor = require('../../../common/models/dialog/dialogColor.js');

var _dialogColor2 = _interopRequireDefault(_dialogColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditInvoiceController = function () {
  function EditInvoiceController(appConfig, authService, $stateParams, $scope, enums, $ngConfirm, accountingService, loadingService, contactService, dialogService, growl, utilsService, $state, printService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EditInvoiceController);
    this.authService = authService;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.enums = enums;
    this.$ngConfirm = $ngConfirm;
    this.accountingService = accountingService;
    this.loadingService = loadingService;
    this.contactService = contactService;
    this.dialogService = dialogService;
    this.growl = growl;
    this.utilsService = utilsService;
    this.$state = $state;
    this.printService = printService;

    this.searchContactUrl = appConfig.apiServiceBaseUri + 'api/contact/search/' + this.authService.authData.currentLocation.key + '/';
    this.searchProductUrl = appConfig.apiServiceBaseUri + 'api/accounting/searchproduct/' + this.authService.authData.currentLocation.key + '/';

    this.contactSelected = this.contactSelected.bind(this);
    this.contactSearched = this.contactSearched.bind(this);
    this.poructSelected = this.poructSelected.bind(this);
    this.productSearched = this.productSearched.bind(this);

    this.vatRates = [{ id: '0', name: '0%' }, { id: '13.5', name: '13.5%' }, { id: '23', name: '23%' }];

    this.$scope.paymentModes = [{ id: null, name: 'Select Payment Method' }, { id: 1, name: 'Cash' }, { id: 2, name: 'Card' }, { id: 3, name: 'EFT' }, { id: 4, name: 'Other' }, { id: 5, name: 'Cheque' }];

    this.invoice = {};
    this.createNewContact = false;
    this.selectedContact = null;
    this.tempLineItem = {};

    this.contactTypes = (0, _appMisc.convertEnumToKeyValueList)(this.enums.CONTACT_TYPE, false);
    this.showInvDatePopup = false;

    this.loadInvoice();
  }

  // #region Contact

  (0, _createClass3.default)(EditInvoiceController, [{
    key: 'contactSearched',
    value: function contactSearched(data) {
      this.createNewContact = data.length === 0;
      return data;
    }
  }, {
    key: 'contactSelected',
    value: function contactSelected(item) {
      if (item) {
        this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchContacts');
        this.invoice.contactId = item.originalObject.contactId;
        this.selectedContact = {
          contactType: item.originalObject.contactTypeId,
          contactPerson: {
            firstName: item.originalObject.firstName,
            lastName: item.originalObject.lastName
          },
          phone: item.originalObject.phone,
          email: item.originalObject.email,
          address: {
            line1: item.originalObject.addressLine1,
            line2: item.originalObject.addressLine2,
            line3: item.originalObject.addressLine3,
            zip: item.originalObject.zip
          }
        };
      }
    }
  }, {
    key: 'clearContact',
    value: function clearContact() {
      this.invoice.contactId = null;
      this.selectedContact = null;
    }
  }, {
    key: 'showNewContact',
    value: function showNewContact() {
      var _this = this;

      this.$scope.errMsg = '';

      this.$scope.contact = {
        contactType: this.enums.CONTACT_TYPE.Customer
      };

      this.$scope.contactTypes = this.contactTypes;

      this.createDialog = this.$ngConfirm({
        title: 'Create Contact',
        contentUrl: 'templates/contact/editContactTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this.validateContact();

              if (valid) {
                _this.loadingService.showLoading('customerManagement', 'Creating Contact ...');

                _this.accountingService.createContact(_this.$this.authService.authData.currentLocation.key, _this.$scope.contact).then(function (response) {
                  _this.invoice.contactId = response.data;
                  _this.selectedContact = {
                    contactType: _this.$scope.contact.contactType,
                    contactPerson: {
                      firstName: _this.$scope.contact.firstName,
                      lastName: _this.$scope.contact.lastName
                    },
                    address: {
                      line1: _this.$scope.contact.line1,
                      line2: _this.$scope.contact.line2,
                      line3: _this.$scope.contact.line3,
                      zip: _this.$scope.contact.zip
                    },
                    phone: _this.$scope.contact.phone,
                    email: _this.$scope.contact.email
                  };
                  _this.createDialog.close();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this.loadingService.hideLoading('customerManagement');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }

    //Need to fix

  }, {
    key: 'showEditContact',
    value: function showEditContact(contact) {
      var _this2 = this;

      var ctrl = this;
      this.$scope.errMsg = '';

      this.$scope.contact = {
        contactType: contact.contactType,
        firstName: contact.contactPerson.firstName,
        lastName: contact.contactPerson.lastName,
        phone: contact.phone,
        email: contact.email,
        line1: contact.address.line1,
        line2: contact.address.line2,
        line3: contact.address.line3,
        zip: contact.address.zip
      };

      this.$scope.contactTypes = this.contactTypes;

      this.editDialog = this.$ngConfirm({
        title: 'Edit Contact',
        contentUrl: 'templates/contact/editContactTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this2.validateContact();

              if (valid) {
                _this2.loadingService.showLoading('customerManagement', 'Updating Contact ...');

                _this2.accountingService.editContact(_this2.authService.authData.currentLocation.key, _this2.invoice.contactId, _this2.$scope.contact).then(function (response) {
                  _this2.selectedContact = {
                    contactType: ctrl.$scope.contact.contactType,
                    contactPerson: {
                      firstName: ctrl.$scope.contact.firstName,
                      lastName: ctrl.$scope.contact.lastName
                    },
                    address: {
                      line1: ctrl.$scope.contact.line1,
                      line2: ctrl.$scope.contact.line2,
                      line3: ctrl.$scope.contact.line3,
                      zip: ctrl.$scope.contact.zip
                    },
                    phone: ctrl.$scope.contact.phone,
                    email: ctrl.$scope.contact.email
                  };
                  _this2.editDialog.close();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this2.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this2.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this2.loadingService.hideLoading('customerManagement');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'validateContact',
    value: function validateContact() {
      if (!this.$scope.contact.contactType) {
        this.$scope.errMsg = 'Please select a contact type.';
        return false;
      }

      if (!this.$scope.contact.firstName || this.$scope.contact.firstName.length < 2) {
        this.$scope.errMsg = 'Please enter a first name.';
        return false;
      }

      if (!this.$scope.contact.lastName || this.$scope.contact.lastName.length < 2) {
        this.$scope.errMsg = 'Please enter a last name.';
        return false;
      }

      if (!this.$scope.contact.phone) {
        this.$scope.errMsg = 'Please enter a phone number.';
        return false;
      }

      if (this.$scope.contact.email && !this.validateEmail(this.$scope.contact.email)) {
        this.$scope.errMsg = 'Please enter a valid email address.';
        return false;
      }

      if (!this.$scope.contact.line1) {
        this.$scope.errMsg = 'Please enter an address in line1.';
        return false;
      }

      return true;
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    // #endregion

    // #region Line Items

  }, {
    key: 'productSearched',
    value: function productSearched(data) {
      if (data.length === 0) {
        this.tempLineItem.title = $('#searchProducts_value').val();
      }

      return data;
    }
  }, {
    key: 'poructSelected',
    value: function poructSelected(item) {
      if (!item) {
        return;
      }

      this.$scope.$broadcast('angucomplete-alt:changeInput', 'searchProducts', item.originalObject.title);

      this.tempLineItem.title = item.originalObject.title;
      this.tempLineItem.quantity = 1;
      this.tempLineItem.price = item.originalObject.price;
      this.tempLineItem.vatRate = item.originalObject.vatRate.toString();

      this.updateLineItemTotals();
    }
  }, {
    key: 'updateLineItemTotals',
    value: function updateLineItemTotals() {
      this.tempLineItem.net = this.tempLineItem.quantity * this.tempLineItem.price;
      this.tempLineItem.vat = this.tempLineItem.net * this.tempLineItem.vatRate / 100;
      this.tempLineItem.total = this.tempLineItem.net + this.tempLineItem.vat;
    }
  }, {
    key: 'addLineItem',
    value: function addLineItem() {
      if (!this.validateLineItem()) {
        return;
      }

      this.updateLineItemTotals();
      this.invoice.lineItems.push(this.tempLineItem);
      this.tempLineItem = {};
      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchProducts');
      this.updateInvoiceTotals();
    }
  }, {
    key: 'validateLineItem',
    value: function validateLineItem() {
      var _this3 = this;

      if (!this.tempLineItem.title || this.tempLineItem.title.length < 2) {
        this.dialogService.error('Please enter a title.');
        return;
      }

      if (this.invoice.lineItems.find(function (l) {
        return l.title.toLowerCase() === _this3.tempLineItem.title.toLowerCase() && !l.editMode;
      })) {
        this.dialogService.error('This item is already in the invoice.');
        return;
      }

      if (!this.tempLineItem.quantity || this.tempLineItem.quantity < 0) {
        this.dialogService.error('Please enter a quantity.');
        return;
      }

      if (!this.tempLineItem.price || this.tempLineItem.price < 0) {
        this.dialogService.error('Please enter a price.');
        return;
      }

      if (!this.tempLineItem.vatRate || this.tempLineItem.vatRate < 0) {
        this.dialogService.error('Please select a VAT rate.');
        return;
      }

      return true;
    }
  }, {
    key: 'removeLineItem',
    value: function removeLineItem(lineItem) {
      this.invoice.lineItems = (0, _lodash.without)(this.invoice.lineItems, lineItem);
      this.updateInvoiceTotals();
    }
  }, {
    key: 'resetLineItem',
    value: function resetLineItem() {
      this.tempLineItem = {
        title: null,
        quantity: null,
        price: null,
        vatRate: null,
        net: null,
        vat: null,
        total: null
      };

      this.$scope.$broadcast('angucomplete-alt:clearInput', 'searchProducts');
    }
  }, {
    key: 'editLineItem',
    value: function editLineItem(lineItem) {
      this.tempLineItem = {
        title: lineItem.title,
        quantity: lineItem.quantity,
        price: lineItem.price,
        vatRate: lineItem.vatRate.toString(),
        net: lineItem.net,
        vat: lineItem.vat,
        total: lineItem.total
      };
      lineItem.editMode = true;
      this.editMode = true;
    }
  }, {
    key: 'updateLineItem',
    value: function updateLineItem(lineItem) {
      if (!this.validateLineItem()) {
        return;
      }

      lineItem.title = this.tempLineItem.title;
      lineItem.quantity = this.tempLineItem.quantity;
      lineItem.price = this.tempLineItem.price;
      lineItem.vatRate = this.tempLineItem.vatRate;
      lineItem.net = this.tempLineItem.net;
      lineItem.vat = this.tempLineItem.vat;
      lineItem.total = this.tempLineItem.total;

      lineItem.editMode = false;
      this.editMode = false;
      this.updateLineItemTotals();
      this.resetLineItem();
      this.updateInvoiceTotals();
    }
  }, {
    key: 'cancelEditLineItem',
    value: function cancelEditLineItem(lineItem) {
      lineItem.editMode = false;
      this.editMode = false;
      this.resetLineItem();
    }

    // #endregion

    // #region Invoice

  }, {
    key: 'loadInvoice',
    value: function loadInvoice() {
      var _this4 = this;

      if (!this.$stateParams.invoiceId) {
        this.invoice = {
          status: this.enums.INVOICE_STATUS.Draft,
          statusName: (0, _appMisc.getEnumPropName)(this.enums.INVOICE_STATUS, this.enums.INVOICE_STATUS.Draft),
          lineItems: [],
          invoiceDate: new Date(),
          dueDate: new Date(),
          discount: 0,
          net: null,
          standardVat: null,
          reducedVat: null,
          total: null,
          notes: null,
          balance: null,
          payments: []
        };
      } else {
        this.loadingService.showLoading('invoicesManagement', 'Loading Invoice ...');
        this.accountingService.getInvoice(this.$stateParams.invoiceId).then(function (response) {
          _this4.invoice = response.data;
          _this4.invoice.invoiceDate = _this4.utilsService.getDatePart(_this4.invoice.invoiceDate);
          _this4.invoice.dueDate = _this4.utilsService.getDatePart(_this4.invoice.dueDate);
          _this4.invoice.lineItems = (0, _lodash.map)(_this4.invoice.lineItems, function (item) {
            item.total = item.net + item.vat;
            return item;
          });

          _this4.selectedContact = {
            contactType: _this4.invoice.contactType,
            contactPerson: {
              firstName: _this4.invoice.firstName,
              lastName: _this4.invoice.lastName
            },
            phone: _this4.invoice.contactPhone,
            email: _this4.invoice.contactEmail,
            address: {
              line1: _this4.invoice.contactAddress1,
              line2: _this4.invoice.contactAddress2,
              line3: _this4.invoice.contactAddress3,
              zip: _this4.invoice.contactZip
            }
          };

          _this4.updateInvoiceTotals();
        }).catch(function (err) {
          _this4.growl.error('Error loading invoice.' + err.data.message, { ttl: 5000 });
        }).finally(function () {
          _this4.loadingService.hideLoading('invoicesManagement');
        });
      }
    }
  }, {
    key: 'updateInvoiceTotals',
    value: function updateInvoiceTotals() {
      this.invoice.net = this.invoice.lineItems.reduce(function (sum, item) {
        return sum + item.net;
      }, 0);
      this.invoice.standardVat = this.invoice.lineItems.filter(function (item) {
        return item.vatRate.toString() === '23';
      }).reduce(function (sum, item) {
        return sum + item.vat;
      }, 0);
      this.invoice.reducedVat = this.invoice.lineItems.filter(function (item) {
        return item.vatRate.toString() === '13.5';
      }).reduce(function (sum, item) {
        return sum + item.vat;
      }, 0);
      this.invoice.total = this.invoice.net + this.invoice.standardVat + this.invoice.reducedVat;

      if (this.invoice.discount && this.invoice.discount > 0) {
        this.invoice.total -= this.invoice.discount;
      }

      this.invoice.balance = this.invoice.total - this.invoice.payments.reduce(function (sum, payment) {
        return sum + payment.amount;
      }, 0);
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(id) {
      this.dtPopups[id] = true;
    }
  }, {
    key: 'getInvoiceEditViewModel',
    value: function getInvoiceEditViewModel() {
      return {
        invoiceId: this.invoice.invoiceId,
        invoiceDate: this.invoice.invoiceDate,
        dueDate: this.invoice.dueDate,
        contactId: this.invoice.contactId,
        net: this.invoice.net,
        discount: this.invoice.discount,
        total: this.invoice.total,
        standardVat: this.invoice.standardVat,
        reducedVat: this.invoice.reducedVat,
        notes: this.invoice.notes,
        lineItems: this.invoice.lineItems.map(function (item) {
          return item;
        })
      };
    }
  }, {
    key: 'validateSaveDraft',
    value: function validateSaveDraft() {
      if (!this.invoice.contactId) {
        this.dialogService.error('Please select a contact.');
        return false;
      }

      return true;
    }
  }, {
    key: 'saveDraft',
    value: function saveDraft() {
      var _this5 = this;

      if (!this.validateSaveDraft()) {
        return;
      }

      this.loadingService.showLoading('invoicesManagement', 'Saving Invoice Draft ...');

      this.accountingService.saveDraft(this.authService.authData.currentLocation.key, this.getInvoiceEditViewModel()).then(function (response) {
        _this5.invoice.invoiceId = response.data;
        _this5.growl.success('Invoice draft saved successfully.', { ttl: 5000 });
      }).catch(function (err) {
        _this5.growl.error('Error saving draft.' + err.data.message, { ttl: 5000 });
      }).finally(function () {
        _this5.loadingService.hideLoading('invoicesManagement');
      });
    }
  }, {
    key: 'editDiscount',
    value: function editDiscount() {
      var _this6 = this;

      //Convert this into dialog service
      this.$ngConfirm({
        title: 'Edit Discount',
        content: '<div class="form-group">\n                  <label for="discount">Discount Amount</label>\n                  <input type="number" class="form-control" id="discount" ng-model="discount" min="0" step="0.01">\n                </div>',
        scope: this.$scope,
        buttons: {
          confirm: {
            text: 'Save',
            btnClass: 'btn-success',
            action: function action() {
              if (_this6.$scope.discount < 0) {
                _this6.dialogService.error('Discount cannot be negative.');
                return false;
              }
              _this6.invoice.discount = _this6.$scope.discount || 0;
              _this6.updateInvoiceTotals();
            }
          },
          cancel: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'delete',
    value: function _delete() {
      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to delete this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, this.deleteInvoice.bind(this)), _dialogButton2.default.cancel());
    }
  }, {
    key: 'deleteInvoice',
    value: function deleteInvoice() {
      var _this7 = this;

      this.loadingService.showLoading('invoicesManagement', 'Deleting Invoice ...');
      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Deleted).then(function () {
        _this7.growl.success('Invoice deleted successfully.', { ttl: 5000 });
        _this7.$state.go('invoicesManagement.container', { locationId: _this7.authService.authData.currentLocation.key }, { reload: true });
      }).catch(function (err) {
        _this7.growl.error('Error deleting invoice.' + err.data.message, { ttl: 5000 });
      }).finally(function () {
        _this7.loadingService.hideLoading('invoicesManagement');
      });
    }
  }, {
    key: 'issue',
    value: function issue() {
      if (this.invoice.lineItems.length === 0) {
        this.dialogService.error('Cannot issue invoice without line items.');
        return;
      }

      this.dialogService.double(_dialogConfig2.default.primary('Are you sure you want to issue this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.PRIMARY, this.issueInvoice.bind(this)), _dialogButton2.default.cancel());
    }
  }, {
    key: 'issueInvoice',
    value: function issueInvoice() {
      var _this8 = this;

      this.loadingService.showLoading('invoicesManagement', 'Issuing Invoice ...');
      this.accountingService.issueInvoice(this.invoice.invoiceId).then(function (response) {
        _this8.invoice.status = _this8.enums.INVOICE_STATUS.Issued;
        _this8.invoice.statusName = (0, _appMisc.getEnumPropName)(_this8.enums.INVOICE_STATUS, _this8.enums.INVOICE_STATUS.Issued);
        _this8.invoice.invoiceNumber = response.data;
        _this8.growl.success('Invoice issued successfully.', { ttl: 5000 });
      }).catch(function (err) {
        if (err.status === 400) {
          _this8.dialogService.error('Error issuing invoice: ' + err.data[0].value);
        } else {
          _this8.growl.error('Error issuing invoice.' + err.data.message, { ttl: 5000 });
        }
      }).finally(function () {
        _this8.loadingService.hideLoading('invoicesManagement');
      });
    }
  }, {
    key: 'paid',
    value: function paid() {
      this.dialogService.double(_dialogConfig2.default.success('Are you sure you want to mark this invoice as paid?'), _dialogButton2.default.new('Yes', _dialogColor2.default.GREEN, this.markAsPaid.bind(this)), _dialogButton2.default.cancel());
    }
  }, {
    key: 'markAsPaid',
    value: function markAsPaid() {
      var _this9 = this;

      this.loadingService.showLoading('invoicesManagement', 'Marking Invoice as Paid ...');
      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Paid).then(function () {
        _this9.invoice.status = _this9.enums.INVOICE_STATUS.Paid;
        _this9.invoice.statusName = (0, _appMisc.getEnumPropName)(_this9.enums.INVOICE_STATUS, _this9.enums.INVOICE_STATUS.Paid);
        _this9.growl.success('Invoice marked as paid successfully.', { ttl: 5000 });
      }).catch(function (err) {
        _this9.growl.error('Error marking invoice as paid.' + err.data.message, { ttl: 5000 });
      }).finally(function () {
        _this9.loadingService.hideLoading('invoicesManagement');
      });
    }
  }, {
    key: 'void',
    value: function _void() {
      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to void this invoice?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, this.voidInvoice.bind(this)), _dialogButton2.default.cancel());
    }
  }, {
    key: 'voidInvoice',
    value: function voidInvoice() {
      var _this10 = this;

      this.loadingService.showLoading('invoicesManagement', 'Voiding Invoice ...');
      this.accountingService.updateInvoiceStatus(this.invoice.invoiceId, this.enums.INVOICE_STATUS.Voided).then(function () {
        _this10.invoice.status = _this10.enums.INVOICE_STATUS.Voided;
        _this10.invoice.statusName = (0, _appMisc.getEnumPropName)(_this10.enums.INVOICE_STATUS, _this10.enums.INVOICE_STATUS.Voided);
        _this10.growl.success('Invoice voided successfully.', { ttl: 5000 });
      }).catch(function (err) {
        _this10.growl.error('Error voiding invoice.' + err.data.message, { ttl: 5000 });
      }).finally(function () {
        _this10.loadingService.hideLoading('invoicesManagement');
      });
    }
  }, {
    key: 'printInvoice',
    value: function printInvoice() {
      this.printService.printInvoice(this.invoice.invoiceId);
    }
  }, {
    key: 'emailInvoice',
    value: function emailInvoice() {
      var _this11 = this;

      if (!this.selectedContact.email) {
        this.dialogService.error('Cannot email invoice. No email address provided for contact.');
        return;
      }

      //Ask user if they want to cc themselves
      this.dialogService.triple(_dialogConfig2.default.primary('Do you want to CC yourself on this invoice?', 'Send Email'), _dialogButton2.default.new('Yes', _dialogColor2.default.PRIMARY, function () {
        return _this11.sendEmail(true);
      }), _dialogButton2.default.new('No', _dialogColor2.default.DARK, function () {
        return _this11.sendEmail(false);
      }), _dialogButton2.default.cancel());
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(cc) {
      var _this12 = this;

      this.loadingService.showLoading('invoicesManagement', 'Emailing Invoice ...');
      this.printService.emailInvoice(this.authService.authData.currentLocation.key, this.invoice.invoiceId, cc).then(function () {
        _this12.growl.success('Invoice email sent successfully.', { ttl: 5000 });
      }).catch(function (err) {
        _this12.growl.error('Error sending invoice email.' + (err.data.message + ' ' + err.data.exceptionMessage), { ttl: 5000 });
      }).finally(function () {
        _this12.loadingService.hideLoading('invoicesManagement');
      });

      return true;
    }

    // #endregion

    // #region Payments

  }, {
    key: 'showAddPaymentModal',
    value: function showAddPaymentModal() {
      var _this13 = this;

      this.$scope.payment = {
        paymentMode: null,
        timeStamp: new Date(),
        amount: null,
        comments: null
      };

      this.$scope.errMsg = '';

      this.addPaymentDialog = this.$ngConfirm({
        title: 'Add Payment',
        contentUrl: 'templates/accounting/editInvoicePaymentTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this13.validateAddPayment();

              if (valid) {
                _this13.loadingService.showLoading('invoicePayments', 'Adding payment ...');

                _this13.accountingService.updatePayment(_this13.authService.authData.currentLocation.key, _this13.invoice.invoiceId, _this13.$scope.payment).then(function (response) {
                  _this13.growl.success('Payment added successfully.', { ttl: 5000 });
                  _this13.invoice.payments.push({
                    invoicePaymentId: response.data,
                    paymentMode: _this13.$scope.paymentModes[_this13.$scope.payment.paymentMode].name,
                    timeStamp: _this13.$scope.payment.timeStamp,
                    amount: _this13.$scope.payment.amount,
                    comments: _this13.$scope.payment.comments,
                    receivedBy: _this13.authService.authData.firstName + ' ' + _this13.authService.authData.lastName
                  });
                  _this13.addPaymentDialog.close();
                  _this13.updateInvoiceTotals();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this13.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this13.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this13.loadingService.hideLoading('invoicePayments');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'showEditPaymentModal',
    value: function showEditPaymentModal(payment) {
      var _this14 = this;

      this.$scope.payment = {
        invoicePaymentId: payment.invoicePaymentId,
        paymentMode: this.stringToId(payment.paymentMode, this.$scope.paymentModes),
        timeStamp: this.utilsService.getDatePart(payment.timeStamp),
        amount: payment.amount,
        comments: payment.comments
      };

      this.$scope.errMsg = '';

      this.addPaymentDialog = this.$ngConfirm({
        title: 'Add Payment',
        contentUrl: 'templates/accounting/editInvoicePaymentTemplate',
        typeAnimation: false,
        columnClass: 'l',
        scope: this.$scope,
        buttons: {
          yes: {
            text: 'Save Changes',
            btnClass: 'btn-success',
            action: function action() {
              var valid = _this14.validateAddPayment(payment.invoicePaymentId);

              if (valid) {
                _this14.loadingService.showLoading('invoicePayments', 'Adding payment ...');

                _this14.accountingService.updatePayment(_this14.authService.authData.currentLocation.key, _this14.invoice.invoiceId, _this14.$scope.payment).then(function (response) {
                  _this14.growl.success('Payment updated successfully.', { ttl: 5000 });

                  payment.paymentMode = _this14.$scope.paymentModes[_this14.$scope.payment.paymentMode].name;
                  payment.timeStamp = _this14.$scope.payment.timeStamp.toJSON();
                  payment.amount = _this14.$scope.payment.amount;
                  payment.comments = _this14.$scope.payment.comments;
                  payment.receivedBy = _this14.authService.authData.firstName + ' ' + _this14.authService.authData.lastName;

                  _this14.addPaymentDialog.close();
                  _this14.updateInvoiceTotals();
                }).catch(function (err) {
                  switch (err.status) {
                    case 400:
                      _this14.$scope.errMsg = err.data[0].value;
                      break;

                    default:
                      _this14.$scope.errMsg = err.data.message;
                      break;
                  }
                }).finally(function () {
                  _this14.loadingService.hideLoading('invoicePayments');
                });
              }

              return false;
            }
          },
          no: {
            text: 'Cancel',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'showDeletePaymentModal',
    value: function showDeletePaymentModal(payment) {
      var _this15 = this;

      this.deletePayment.bind(this);
      this.dialogService.double(_dialogConfig2.default.red('Are you sure you want to delete this payment?'), _dialogButton2.default.new('Yes', _dialogColor2.default.RED, function () {
        return _this15.deletePayment(payment);
      }), _dialogButton2.default.cancel());
    }
  }, {
    key: 'deletePayment',
    value: function deletePayment(payment) {
      var _this16 = this;

      this.loadingService.showLoading('invoicePayments', 'Deleting payment ...');
      this.accountingService.deletePayment(this.authService.authData.currentLocation.key, payment.invoicePaymentId).then(function () {
        _this16.growl.success('Payment deleted successfully.', { ttl: 5000 });
        _this16.invoice.payments = _this16.invoice.payments.filter(function (p) {
          return p.invoicePaymentId !== payment.invoicePaymentId;
        });
        _this16.updateInvoiceTotals();
      }).catch(function (err) {
        switch (err.status) {
          case 400:
            _this16.$scope.errMsg = err.data[0].value;
            break;
          default:
            _this16.$scope.errMsg = err.data.message;
            break;
        }
      }).finally(function () {
        _this16.loadingService.hideLoading('invoicePayments');
      });

      return true;
    }
  }, {
    key: 'validateAddPayment',
    value: function validateAddPayment(invoicePaymentId) {
      this.$scope.errMsg = null;

      if (!this.$scope.payment.paymentMode) {
        this.$scope.errMsg = 'Please select a payment method.';
        return false;
      }

      if (!this.$scope.payment.amount || this.$scope.payment.amount <= 0) {
        this.$scope.errMsg = 'Please enter a valid amount.';
        return false;
      }

      var balance = this.invoice.total - this.invoice.payments.reduce(function (sum, payment) {
        return sum + payment.amount;
      }, 0);

      if (invoicePaymentId) {
        balance += this.invoice.payments.find(function (p) {
          return p.invoicePaymentId === invoicePaymentId;
        }).amount;
      }

      if (this.$scope.payment.amount > balance) {
        this.$scope.errMsg = 'Payment amount cannot exceed the invoice balance of ' + balance.toFixed(2) + '.';
        return false;
      }

      return true;
    }
  }, {
    key: 'stringToId',
    value: function stringToId(strName, collection) {
      if (!strName || !collection) {
        return null;
      }

      var item = (0, _lodash.find)(collection, { name: strName });
      return item ? item.id : null;
    }
  }, {
    key: 'printPaymentReceipt',
    value: function printPaymentReceipt() {
      this.printService.printInvoicePaymentReceipt(this.invoice.invoiceId);
    }

    // #endregion

  }]);
  return EditInvoiceController;
}();

exports.default = EditInvoiceController;


// WEBPACK FOOTER //
// ./client/app/components/accounting/editInvoice/editInvoice.controller.js